import React, { useCallback, useEffect, useState } from 'react';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import omit from 'lodash.omit';
import ProjectOwnerTableData from './ProjectOwnerTableData';
import generalRouteSubRouteService from '@rd-web-markets/shared/dist/services/general_route_subroute.service';
import projectOwnerService from '@rd-web-markets/market/dist/services/elster/project_onwer.service';
const notSavedStyle = {
  borderLeft: '5px solid red'
};
const ProjectOwnerRow = _ref => {
  let {
    rowData,
    setProjectReports,
    setSelectedProject,
    projectReports,
    removeEmptyRow,
    emptyRowId = null
  } = _ref;
  const {
    uploadAllowed,
    body,
    uploadFile,
    saveData,
    createNewData,
    deleteData,
    isSaved,
    setIsSaved,
    setBody,
    setUploadAllowed
  } = projectOwnerService.useCrud(rowData, projectReports, setProjectReports, removeEmptyRow, emptyRowId, setSelectedProject);
  return /*#__PURE__*/React.createElement("tr", {
    className: rowData.id ? '' : 'newRow'
  }, /*#__PURE__*/React.createElement(ProjectOwnerTableData, {
    isSaved: isSaved,
    setIsSaved: setIsSaved,
    notSavedStyle: notSavedStyle,
    body: body,
    setBody: setBody,
    saveData: saveData,
    deleteData: deleteData,
    rowData: rowData,
    uploadFile: uploadFile,
    uploadAllowed: uploadAllowed,
    setUploadAllowed: setUploadAllowed,
    createNewData: createNewData,
    emptyRowId: emptyRowId,
    removeEmptyRow: removeEmptyRow,
    projectReports: projectReports
  }));
};
export default ProjectOwnerRow;